import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components';
import theme from '../../theme';
import store from './store';
import {
  INIT,
  LOAD,
  ERROR,
} from './STATES';

class ProfilePicture extends React.PureComponent {
  static propTypes = {
    user: PropTypes.shape({
      name: PropTypes.string,
      picture: PropTypes.string,
    }),
    onInit: PropTypes.func.isRequired,
    onLoad: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    error: PropTypes.bool,
    loaded: PropTypes.bool,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    user: null,
    error: false,
    loaded: false,
    loading: false,
  };

  componentWillMount() {
    const {
      user,
      error,
      loading,
      onInit,
    } = this.props;
    if (user && user.picture && !loading && !error) {
      onInit(user.picture);
    }
  }

  render() {
    const {
      user,
      error,
      loaded,
      loading,
      onInit,
      onLoad,
      onError,
      storeSubscription, // eslint-disable-line
      dispatch, // eslint-disable-line
      ...props
    } = this.props;
    if (user && user.picture && !error) {
      return (
        <img
          alt={user.name || 'ProfilePicture'}
          src={user.picture}
          onLoad={() => onLoad(user.picture)}
          onError={() => onError(user.picture)}
          {...props}
        />
      );
    }
    return (
      <i {...props} />
    );
  }
}

const ProfileIcon = styled.i`
  background: ${theme.colors.action};
  border-radius: 50%;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: middle;
  overflow: hidden;
  position: relative;

  ${({ showIcon }) => showIcon && `
    &::after {
      background: ${theme.colors.white};
      border-radius: 50%;
      content: '';
      display: block;
      height: 40%;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -75%);
      width: 40%;
    }

    &::before {
      background: ${theme.colors.white};
      border-radius: 50%;
      content: '';
      display: block;
      height: 75%;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, 25%);
      width: 75%;
    }
  `}

  ${({ small, large }) => small && !large && `
    height: ${theme.unit * 4}px;
    width: ${theme.unit * 4}px;
    margin: ${theme.unit * 0.5}px ${theme.unit}px ${theme.unit * 0.5}px 0;
  `};

  ${({ small, large }) => !small && large && `
    height: ${theme.unit * 10}px;
    width: ${theme.unit * 10}px;
  `};

  ${({ small, large }) => !small && !large && `
    height: ${theme.unit * 5}px;
    width: ${theme.unit * 5}px;
    margin: ${theme.unit * 0.25}px ${theme.unit / 2}px ${theme.unit * 0.25}px 0;
  `};

  ${({ small, large, showIcon }) => showIcon && ((small || large) ? `
    border: solid 2px ${theme.colors.action};
  ` : `
    border: solid 3px ${theme.colors.action};
  `)};
`.withComponent(({
  small, large, showIcon, // ignore
  ...props
}) => <ProfilePicture {...props} />);

ProfileIcon.propTypes = {
  user: PropTypes.object,
};
ProfileIcon.defaultProps = {
  user: null,
};
export default compose(
  connect(() => ({ store })),
  connect(
    state => ({ state }),
    dispatch => ({
      onInit: _id => dispatch({
        type: INIT,
        _id,
      }),
      onLoad: _id => dispatch({
        type: LOAD,
        _id,
      }),
      onError: _id => dispatch({
        type: ERROR,
        _id,
      }),
    }),
    ({ state }, actions, props) => {
      const { user } = props;
      const { picture } = user || {};
      const status = state[picture] || null;
      return {
        ...props,
        ...actions,
        error: status === ERROR,
        loaded: status === LOAD,
        loading: status === INIT,
        showIcon: !status || [ERROR, INIT].includes(status),
      };
    },
  ),
)(ProfileIcon);



// WEBPACK FOOTER //
// ./src/components/stateful/ProfileIcon/index.js